"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../uploadFile/types");
/**
 * FileData type guard.
 */
exports.isFileDataArray = function (data) {
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var item = data_1[_i];
        if (!types_1.isFileData(item)) {
            return false;
        }
    }
    return true;
};
/**
 * Uuid type guard.
 */
exports.isUuidArray = function (data) {
    for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
        var item = data_2[_i];
        if (!types_1.isUuid(item)) {
            return false;
        }
    }
    return true;
};
/**
 * Url type guard.
 */
exports.isUrlArray = function (data) {
    for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
        var item = data_3[_i];
        if (!types_1.isUrl(item)) {
            return false;
        }
    }
    return true;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/uploadFileGroup/types.js
// module id = 1273
// module chunks = 70